module.exports = __webpack_public_path__ + "media/images/version_merge/fdf/img-3db73f318ee7bda694964c49653c83ae.png";